{
  "previous": "Anterior",
  "next": "Siguiente",
  "complete": "Completar",
  "verifyAndCheckIn": "Verificar y registrar entrada",
  "loading": {
    "retrievingLocation": "Obteniendo ubicación...",
    "retrievingWarehouse": "Obteniendo datos del almacén..."
  },
  "validation": {
    "fieldRequired": "Este campo es obligatorio",
    "fieldRequiredWithLabel": "{label} es obligatorio",
    "phoneInvalid": "Este no es un número de teléfono válido",
    "phoneInvalidWithExample": "Este no es un número de teléfono válido (ejemplo: {example})"
  }
}
